/* eslint-disable react/jsx-pascal-case */
import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { toNumber, getItemFromArray } from "../../components/Common";

import PropTypes from "prop-types";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Paper from "@material-ui/core/Paper";
import Draggable from "react-draggable";
import Typography from "@material-ui/core/Typography";
import Slider from "@material-ui/core/Slider";
import TextField from "@material-ui/core/TextField";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import WarningIcon from "@material-ui/icons/Warning";

import { blue } from "@material-ui/core/colors";

import {
    updateAreaSpecificationModificationArray,
    deleteFromAreaSpecificationModificationArray,
} from "../../redux_store/jobState";
import BSL_Select from "../../components/BSL_Select";

const AttachmentSlider = withStyles({
    root: {
        color: "#3a8589",
        height: 3,
        padding: "13px 0",
        marginTop: "20px",
    },
    thumb: {
        height: 24,
        width: 24,
        backgroundColor: "#fff",
        border: "2px solid currentColor",
        marginTop: -8,
        marginLeft: -12,
        "&:focus, &:hover, &$active": {
            boxShadow: "inherit",
        },
    },
    active: {},
    valueLabel: {
        left: "calc(-50% + 3px)",
        top: 30,
        "& *": {
            background: "transparent",
            color: "#000",
        },
    },
    track: {
        height: 30,
        marginTop: -23,
        background: "repeating-linear-gradient(45deg,#B1B118,#B1B118 2px,#F0F2E6 2px,#F0F2E6 10px)",
    },
    rail: {
        color: "#FFF",
        opacity: 1,
        height: 5,
        border: "1px solid #7AB004",
    },
})(Slider);

function PaperComponent(props) {
    return (
        <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
            <Paper id="draggable-dialog-title" {...props} />
        </Draggable>
    );
}

const useStyles = makeStyles({
    avatar: {
        backgroundColor: blue[100],
        color: blue[600],
    },
    root: {
        width: 300,
    },
    handleText: {
        textAlign: "center",
        background: "#0000",
        width: "60px",
        border: "1px",
        position: "absolute",
        top: "-35px",
    },
    attachLengthText: {
        textAlign: "center",
        width: "55px",
        border: "0px",
    },
    label: {
        whiteSpace: "nowrap",
    },
});

function valuetext(value) {
    return `{value}mm`;
}

export default function SpecModifyAttachmentDialog(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { onClose, selectedValue, open, item } = props;
    const logged_user_code = useSelector((state) => state.app.logged_user_code);
    const job = useSelector((state) => state.job);
    const JobExistingStructure = useSelector((state) => state.job.SiteParameters.ExistingStructure);
    const AreaSpecifications = useSelector((state) => state.job.AreaSpecifications);
    const is_deck_mode = useSelector((state) => state.job?.DesignParameters?.DeckMode);
    const areaData = AreaSpecifications[item.areaIndex];
    const areaDataAttachments = areaData.ATTACHMENTS;
    const areaDataPartialAttachments = areaDataAttachments.PARTIAL_ATTACHMENTS;
    const areaDataAttachmentModifications = areaDataAttachments.AttachmentModifications;

    let ref = item ? (item?.ref2 ? item?.ref2 : item?.ref) : null;
    if (ref === "GutterB") ref = "Back 1";
    if (ref === "GutterF") ref = "Front 1";
    if (ref === "GutterL") ref = "Left 1";
    if (ref === "GutterR") ref = "Right 1";

    let data_paat = getItemFromArray(areaDataPartialAttachments, "Ref", ref);
    let data_mods = getItemFromArray(areaDataAttachmentModifications, "Ref", ref);
    const max = item ? item.lengthQQ : 6000;

    //defaults
    const default_EaveDepth = JobExistingStructure ? JobExistingStructure.EaveDepth : 0;
    const default_WallHeight = JobExistingStructure ? JobExistingStructure.WallHeight : 4000;
    const default_FasciaType = JobExistingStructure ? JobExistingStructure.AttachmentType : "Timber Fascia Drop";
    const default_FrameType = JobExistingStructure ? JobExistingStructure.FrameType : "Timber Frame - Brick Veneer";

    const config = useSelector((state) => state.config);
    const ConfigDesignOptions = useSelector((state) => state.config.design_options);
    const designType = AreaSpecifications[item.areaIndex].SHAPE.DesignType;
    const design_options = ConfigDesignOptions[designType];

    const handleClose = () => {
        onClose();
    };

    const handleListItemClick = (value) => {
        onClose(value);
    };

    const handleDelete = () => {
        setPaatValues([0, max]);
        setPaatGutterValue(false);
        setAttachmentLabel("");
        setEaveValue(default_EaveDepth);
        setWallHeight(default_WallHeight);
        setAttachmentType(default_FasciaType);
        setAttachmentSubType("");
        setnumBrackets(0);
        setRSBLC(false);
        // dispatch(deleteFromAreaSpecificationModificationArray(item.areaIndex, "ATTACHMENTS.PARTIAL_ATTACHMENTS", ref, false));
        // dispatch(deleteFromAreaSpecificationModificationArray(item.areaIndex, "ATTACHMENTS.AttachmentModifications", ref, true));
        // onClose();
    };

    const saveAttachmentModifications = () => {
        let new_data_paat = data_paat ? { ...data_paat } : {};
        new_data_paat.Ref = ref;
        new_data_paat.Name = ref;
        let p1 = paatValues[0];
        let p2 = paatValues[1];
        let attach_length = p2 - p1;
        if (attach_length >= max) {
            //delete paat from list
            dispatch(
                deleteFromAreaSpecificationModificationArray(
                    item.areaIndex,
                    "ATTACHMENTS.PARTIAL_ATTACHMENTS",
                    ref,
                    false
                )
            );
        } else {
            if (p1 > 0 && p2 >= max - 10) {
                new_data_paat.Kind = "NA";
                new_data_paat.Length = attach_length;
                new_data_paat.Offset = p1;
            } else if (p1 <= 10) {
                new_data_paat.Kind = "AN";
                new_data_paat.Length = attach_length;
                new_data_paat.Offset = p1;
            } else {
                new_data_paat.Kind = "NAN";
                new_data_paat.Length = attach_length;
                new_data_paat.Offset = p1;
            }
            new_data_paat.HasGutter = paatGutterValue ? 0 : 1;
            new_data_paat.HasBeam = 1;

            dispatch(
                updateAreaSpecificationModificationArray(
                    item.areaIndex,
                    "ATTACHMENTS.PARTIAL_ATTACHMENTS",
                    ref,
                    null,
                    new_data_paat,
                    false
                )
            );
        }

        let new_data_mods = data_mods ? { ...data_mods } : {};
        new_data_mods.Ref = ref;
        new_data_mods.Name = ref;

        new_data_mods.AttachmentLabel = attachmentLabel;
        new_data_mods.EaveWidth = isNaN(eaveValue) ? "" : Number(eaveValue);
        new_data_mods.HasEaveWidth =
            new_data_mods.EaveWidth !== "" && new_data_mods.EaveWidth !== default_EaveDepth ? 1 : 0;
        new_data_mods.WallHeight = isNaN(wallHeightValue) ? "" : Number(wallHeightValue);
        new_data_mods.HasWallHeight =
            new_data_mods.WallHeight !== "" && new_data_mods.WallHeight !== default_WallHeight ? 1 : 0;

        new_data_mods.AttachmentType = attachmentTypeValue;
        new_data_mods.AttachmentSubType = attachmentSubTypeValue;

        // let fasciaTypeValue = "Timber Fascia Drop";

        // if (config?.attachment_types?.[attachmentTypeValue]) {
        //     let attachmentType = config?.attachment_types?.[attachmentTypeValue];
        //     if (attachmentType?.has_beam) {
        //         fasciaTypeValue = "Beam";
        //     }
        //     if (attachmentType?.to_wall) {
        //         fasciaTypeValue = "Wall";
        //     }
        // }

        // if (attachmentTypeValue === "") fasciaTypeValue = "";

        // } else {
        //     attachment_options.push({
        //         Key: "",
        //         Display: "Default (" + default_FasciaType + ")",
        //     });
        //     attachment_options.push({
        //         Key: "Timber Fascia Drop",
        //         Display: "Timber Fascia",
        //     });
        //     attachment_options.push({
        //         Key: "Metal Fascia Drop",
        //         Display: "Metal Fascia",
        //     });
        //     attachment_options.push({
        //         Key: "Beam",
        //         Display: "Beam",
        //     });
        //     attachment_options.push({
        //         Key: "Riser",
        //         Display: "Riser",
        //     });
        //     attachment_options.push({
        //         Key: "Wall",
        //         Display: "Wall",
        //     });
        // }

        new_data_mods.FasciaType = attachmentTypeValue;
        new_data_mods.HasFasciaType =
            new_data_mods.FasciaType !== "" && new_data_mods.FasciaType !== default_FasciaType ? 1 : 0;
        new_data_mods.NumBrackets = isNaN(numBrackets) ? 0 : Number(numBrackets);
        if (!new_data_mods.NumBrackets) new_data_mods.NumBrackets = 0;
        if (new_data_mods.NumBrackets > max_rafters) new_data_mods.NumBrackets = max_rafters;
        if (new_data_mods.NumBrackets < min_rafters) new_data_mods.NumBrackets = 0;

        new_data_mods.HasNumBrackets =
            new_data_mods.NumBrackets !== "" && new_data_mods.NumBrackets >= min_rafters ? 1 : 0;
        new_data_mods.AllowRSBLC = rSBLC ? 1 : 0;
        new_data_mods.WallOnly = 0;

        // move to validation??
        // if (window.LYSAGHT) {
        //     new_data_mods.HasBracketType = 0;
        //     new_data_mods.BracketType = "";
        //     new_data_mods.BracketSpacing = 0;
        //     if (new_data_mods.AttachmentType === "Wall") {
        //         if (new_data_mods.AttachmentSubType === "Timber Wall") {
        //             new_data_mods.HasBracketType = 1;
        //             new_data_mods.BracketType = "R/C w/ Coach Screws";
        //             new_data_mods.BracketTypeCode = "CS7510G";
        //             new_data_mods.BracketSpacing = 600;
        //         } else if (new_data_mods.AttachmentSubType === "Timber Wall On Beam") {
        //             new_data_mods.HasBracketType = 1;
        //             new_data_mods.BracketType = "R/C on Beam w/ Coach Screws";
        //             new_data_mods.BracketTypeCode = "CS7510G";
        //             new_data_mods.BracketSpacing = 600;
        //         } else if (new_data_mods.AttachmentSubType === "Masonry Wall") {
        //             new_data_mods.HasBracketType = 1;
        //             new_data_mods.BracketType = "R/C w/ Masonry Anchors";
        //             new_data_mods.BracketTypeCode = "SA7510G";
        //             new_data_mods.BracketSpacing = 600;
        //         } else if (new_data_mods.AttachmentSubType === "Masonry Wall On Beam") {
        //             new_data_mods.HasBracketType = 1;
        //             new_data_mods.BracketType = "R/C on Beam w/ Masonry Anchors";
        //             new_data_mods.BracketTypeCode = "SA7510G";
        //             new_data_mods.BracketSpacing = 600;
        //         }
        //         new_data_mods.WallOnly = 1;
        //     }
        //     if (new_data_mods.AttachmentType === "Timber Fascia Drop") {
        //         new_data_mods.HasBracketType = 1;
        //         new_data_mods.BracketType = "CON110";
        //         new_data_mods.BracketTypeCode = "CON110";
        //         new_data_mods.BracketSpacing = JobExistingStructure?.RoofType === "Tile" ? 600 : 900;
        //     }
        //     if (new_data_mods.AttachmentType === "Metal Fascia Drop") {
        //         new_data_mods.HasBracketType = 1;
        //         new_data_mods.BracketType = "CON110";
        //         new_data_mods.BracketTypeCode = "CON110";
        //         new_data_mods.BracketSpacing = JobExistingStructure?.RoofType === "Tile" ? 600 : 900;
        //     }
        // } else {
        //     new_data_mods.HasBracketType = 0;
        //     new_data_mods.BracketType = "";
        //     new_data_mods.BracketSpacing = 0;
        // }

        // new_data_mods.HasBracketType = 1;
        // new_data_mods.HasBracketType = 1;

        // console.log("new_data_mods",new_data_mods);

        if (
            new_data_mods.HasEaveWidth ||
            new_data_mods.HasWallHeight ||
            new_data_mods.HasFasciaType ||
            new_data_mods.HasNumBrackets ||
            new_data_mods.AttachmentLabel !== "" ||
            new_data_mods.BracketSpacing > 0
        ) {
            dispatch(
                updateAreaSpecificationModificationArray(
                    item.areaIndex,
                    "ATTACHMENTS.AttachmentModifications",
                    ref,
                    null,
                    new_data_mods,
                    true
                )
            );
        } else {
            //delete paat from list
            dispatch(
                deleteFromAreaSpecificationModificationArray(
                    item.areaIndex,
                    "ATTACHMENTS.AttachmentModifications",
                    ref,
                    true
                )
            );
        }

        onClose();
    };

    let p1 = 0;
    let p2 = max;

    // PAAT

    // Name:"Back 1",
    // Kind:"NAN",
    // Length:4000,
    // Offset:1000,
    // HasBeam:1,
    // HasGutter:1,

    if (data_paat) {
        if (data_paat.Kind === "NAN") {
            p1 = data_paat.Offset;
            p2 = data_paat.Offset + data_paat.Length;
        } else if (data_paat.Kind === "AN") {
            p1 = 0;
            p2 = data_paat.Length;
        } else {
            p1 = max - data_paat.Length;
            p2 = max;
        }
    }

    const [paatValues, setPaatValues] = React.useState([p1, p2]);
    const handlePaatValuesChange = (event, newValue) => {
        setPaatValues(newValue);
    };
    const [paatGutterValue, setPaatGutterValue] = React.useState(data_paat ? data_paat.HasGutter === 0 : false);
    const handlePaatGutterChange = (event, newValue) => {
        setPaatGutterValue(newValue);
    };

    const attach_length = paatValues[1] - paatValues[0];
    const [attachDisplay, setAttachDisplay] = React.useState(null);

    // MODS

    // Name:"Back 1",
    // HasEaveWidth:0,
    // EaveWidth:35,
    // HasWallHeight:0,
    // WallHeight:2500,
    // HasFasciaType:0,
    // FasciaType:"Beam",
    // AttachmentLabel:"werwer",
    // HasNumBrackets:1,
    // NumBrackets:44,
    // HasBracketType:0,
    // AllowRSBLC:1,

    const [attachmentLabel, setAttachmentLabel] = React.useState(data_mods ? data_mods.AttachmentLabel : "");
    const handleAttachmentLabel = (event, newValue) => {
        setAttachmentLabel(newValue !== undefined ? newValue : event.target.value);
    };
    const [eaveValue, setEaveValue] = React.useState(data_mods ? data_mods.EaveWidth : default_EaveDepth);
    const handleEaveValue = (event, newValue) => {
        setEaveValue(newValue !== undefined ? newValue : event.target.value);
    };
    const [wallHeightValue, setWallHeight] = React.useState(data_mods ? data_mods.WallHeight : default_WallHeight);
    const handleWallHeight = (event, newValue) => {
        setWallHeight(newValue !== undefined ? newValue : event.target.value);
    };
    const [attachmentTypeValue, setAttachmentType] = React.useState(
        data_mods?.AttachmentType ? data_mods.AttachmentType : ""
    );
    const handleAttachmentType = (event, newValue) => {
        console.log("newValue", newValue);
        console.log("event", event);

        let val = newValue !== undefined ? newValue.props.value : event.target.value;
        if (val === "Wall") setEaveValue(0);
        if (val === "Wall") {
            setWallHeight(areaData.SHAPE.Height + 500);
        }
        setAttachmentType(val);
    };
    const [attachmentSubTypeValue, setAttachmentSubType] = React.useState(
        data_mods?.AttachmentSubType ? data_mods.AttachmentSubType : ""
    );
    const handleAttachmentSubType = (event, newValue) => {
        console.log("newValue", newValue);
        console.log("event", event);
        setAttachmentSubType(newValue !== undefined ? newValue.props.value : event.target.value);
    };

    let min_rafters = 2; // as only for flyover now...
    let spacing = 6100;

    if (
        attachmentTypeValue.includes("Flyover") ||
        (attachmentTypeValue === "" && default_FasciaType.includes("Flyover"))
    ) {
        if (job?.SiteParameters?.FlyoverBracketSpacing) spacing = job?.SiteParameters?.FlyoverBracketSpacing;
    } else if (job?.SiteParameters?.RafterBracketSpacing) {
        spacing = job?.SiteParameters?.RafterBracketSpacing;
    }

    let recommended_brackets = Math.trunc(attach_length / spacing + 0.999999) + 1;
    let max_rafters = min_rafters * 3;
    if (max_rafters < 10) max_rafters = 12;

    let num_brackets = 0;
    if (data_mods && data_mods.NumBrackets) num_brackets = data_mods.NumBrackets;
    if (num_brackets < min_rafters) num_brackets = 0;
    if (num_brackets > max_rafters) num_brackets = max_rafters;

    let rafterBracketMenuItems = [];
    rafterBracketMenuItems.push(<MenuItem value={0}>Auto</MenuItem>);
    for (let step = min_rafters; step < max_rafters + 1; step++) {
        rafterBracketMenuItems.push(
            <MenuItem value={step}>
                {step}
                {step === recommended_brackets ? " (Recommended)" : ""}
            </MenuItem>
        );
    }

    const [numBrackets, setnumBrackets] = React.useState(num_brackets);
    const handleNumBrackets = (event, newValue) => {
        setnumBrackets(newValue !== undefined ? newValue.props.value : event.target.value);
    };
    const [rSBLC, setRSBLC] = React.useState(data_mods ? data_mods.AllowRSBLC === 1 : false);
    const handleRSBLC = (event, newValue) => {
        setRSBLC(newValue);
    };

    // const handleChange = (event, newValue) => {
    //   setValue(newValue);
    // };

    let attsch_length_display = attachDisplay;
    if (attsch_length_display === null || attsch_length_display === undefined) attsch_length_display = attach_length;

    function AirbnbThumbComponent(props) {
        const classes = useStyles();
        const [thisValue, setThisValue] = React.useState(props["aria-valuenow"]);

        console.log(props);
        let display_value = thisValue;
        if (display_value === null && props["aria-valuenow"]) display_value = props["aria-valuenow"];

        const data_index = props["data-index"];

        return (
            <span {...props}>
                <input
                    type="text"
                    id="standard-basic"
                    label=""
                    value={display_value}
                    className={classes.handleText}
                    onMouseDown={(e) => e.stopPropagation()}
                    onChange={(e) => setThisValue(e.target.value)}
                    onBlur={() => {
                        let new_value = [...paatValues];
                        new_value[data_index] = toNumber(display_value);
                        console.log(new_value);
                        setPaatValues(new_value);
                    }}
                    onFocus={(event) => {
                        event.target.select();
                    }}
                    onKeyPress={(e) => {
                        if (e.key === "Enter") {
                            e.target.blur();
                        }
                    }}
                />
            </span>
        );
    }
    console.log("attachmentTypeValue", attachmentTypeValue);

    let attachment_options = [];

    if (design_options?.attachment_types && config?.attachment_types && window.debug) {
        let attachment_types = {
            "Fascia (Timber) with Receiver Channel": {
                display_name: "Fascia (Timber) with Receiver Channel",
                has_beam: false,
                has_backchannel: true,
                to_wall: false,
                bracket: "CON110",
                beam_attachment_blocking: "",
                bracket_spacing_tile: 1200,
                bracket_spacing_sheet: 900,
                depth_offset_default: 0,
                depth_offset_editable: false,
                height_offset_default: 0,
                height_offset_editable: false,
                items_for_bom: {},
            },
            "Fascia (Steel) with Receiver Channel": {
                display_name: "Fascia (Steel) with Receiver Channel",
                has_beam: false,
                has_backchannel: true,
                to_wall: false,
                bracket: "CON110",
                beam_attachment_blocking: "",
                bracket_spacing_tile: 1200,
                bracket_spacing_sheet: 900,
                depth_offset_default: 0,
                depth_offset_editable: false,
                height_offset_default: 0,
                height_offset_editable: false,
                items_for_bom: {},
            },
            "Fascia (Steel/Timber) with Rafter Brackets supporting Beam": {
                display_name: "Rafter Brackets supporting Beam (Steel/Timber Fascia)",
                has_beam: true,
                has_backchannel: true,
                to_wall: false,
                bracket: "UCEG",
                bracket_for_FL15015: "UCF",
                bracket_for_FL20020: "UCH",
                beam_attachment_blocking: "",
                bracket_spacing_tile: 1200,
                bracket_spacing_sheet: 900,
                depth_offset_default: 0,
                depth_offset_editable: false,
                height_offset_default: 0,
                height_offset_editable: false,
                items_for_bom: {},
            },
            "Fascia (Steel/Timber) with Rafter Brackets supporting Elevated Beam": {
                display_name: "Rafter Brackets supporting Beam (Steel/Timber Fascia)",
                has_beam: true,
                has_backchannel: true,
                to_wall: false,
                bracket: "UCB",
                bracket_spacing_tile: 1200,
                bracket_spacing_sheet: 900,
                attachment_depth_offset: 0,
                attachment_height_offset: 0,
                items_for_bom: {},
            },
            "Wall (Masonry) with Receiver Channel": {
                display_name: "Receiver Channel (on Masonry Wall)",
                has_beam: false,
                has_backchannel: true,
                to_wall: true,
                bracket: "UCB",
                items_for_bom: {},
            },
            "Wall (Timber Frame) with Receiver Channel": {
                display_name: "Receiver Channel (on Masonry Wall)",
                has_beam: false,
                has_backchannel: true,
                to_wall: true,
                items_for_bom: {},
            },
            "Wall with Offset (Box Gutter) Brackets Supporting Beam": {
                display_name: "Offset (Box Gutter) Brackets Supporting Beam (Masonry/Timber Wall)",
                has_beam: true,
                has_backchannel: true,
                to_wall: true,
                items_for_bom: {},
            },
            "Wall Direct to Beam and Receiver Channel on top": {
                display_name: "Wall Attached with Beam and Receiver Channel on top",
                has_beam: false,
                has_backchannel: true,
                to_wall: false,
                items_for_bom: {},
            },
            Flyover: {
                display_name: "Flyover",
                has_beam: false,
                has_backchannel: true,
                to_wall: false,
                items_for_bom: {},
            },
        };

        attachment_options.push({
            Key: "",
            Display: "Job Default (" + default_FasciaType + ")",
        });
        for (let attachment_type of attachment_types) {
            if (config?.attachment_types?.[attachment_type]) {
                let attachment_data = config?.attachment_types?.[attachment_type];
                attachment_options.push({
                    Key: attachment_type,
                    Display: attachment_data?.display_name ? attachment_data?.display_name : attachment_type,
                });
            }
        }

        // attachment_options.push({
        //     Key: "",
        //     Display: "Default (" + default_FasciaType + ")",
        // });
    } else {
        attachment_options.push({
            Key: "",
            Display: "Default (" + default_FasciaType + ")",
        });
        attachment_options.push({
            Key: "Timber Fascia Drop",
            Display: "Timber Fascia",
        });
        attachment_options.push({
            Key: "Metal Fascia Drop",
            Display: "Metal Fascia",
        });
        attachment_options.push({
            Key: "Beam",
            Display: "Beam",
            disabled: window.debug ? false : true,
        });
        attachment_options.push({
            Key: "Riser",
            Display: "Riser",
        });
        attachment_options.push({
            Key: "Wall",
            Display: "Wall",
        });
        if (window.debug)
            attachment_options.push({
                Key: "Flyover",
                Display: "Flyover",
            });
    }

    let attachment_subtype_options = [];

    if (window.LYSAGHT) {
        if (attachmentTypeValue == "Wall") {
            attachment_subtype_options.push({
                Key: "Timber Wall",
                Display: "Receiver Channel to Timber Wall (Coach Screws)",
            });
            attachment_subtype_options.push({
                Key: "Timber Wall On Beam",
                Display: "Receiver Channel on Beam to Timber Wall (Coach Screws)",
            });
            attachment_subtype_options.push({
                Key: "Masonry Wall",
                Display: "Receiver Channel to Masonry Wall (Dynabolts Screws)",
            });
            attachment_subtype_options.push({
                Key: "Masonry Wall On Beam",
                Display: "Receiver Channel on Beam to Masonry Wall (Dynabolts Screws)",
            });
        }
    }
    if (
        attachment_subtype_options.length > 0 &&
        attachment_subtype_options.filter((e) => e.Key === attachmentSubTypeValue).length === 0
    ) {
        let new_sub_option = attachment_subtype_options?.[0]?.Key ? attachment_subtype_options?.[0]?.Key : "";
        if (attachmentTypeValue == "Wall") {
            if (default_FrameType.includes("Brick") || default_FrameType.includes("Masonry"))
                new_sub_option = "Masonry Wall";
            else new_sub_option = "Timber Wall";
        }
        setAttachmentSubType(new_sub_option);
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
        >
            <DialogTitle style={{ cursor: "move" }}>
                Modify Attachment Options {window.debug ? "ref " + ref : ""}
            </DialogTitle>
            <DialogContent style={{ overflow: "hidden", display: "flex", flexDirection: "column" }}>
                {!item && <DialogContentText>Attachment data is not defined</DialogContentText>}
                {item && (
                    <DialogContentText style={{ display: "flex", flexDirection: "column" }}>
                        <TextField
                            id="standard-basic"
                            label="Label for this attachment"
                            value={attachmentLabel}
                            onChange={handleAttachmentLabel}
                        />
                        {!is_deck_mode && (
                            <BSL_Select
                                label={"Attachment Type (default: " + default_FasciaType + ")"}
                                value={attachmentTypeValue}
                                tight={true}
                                items={attachment_options}
                                onChange={handleAttachmentType}
                            />
                            // <FormControl className={classes.formControl}>
                            //     <InputLabel id="demo-simple-select-label">
                            //         Attachment Type (default: {default_FasciaType})
                            //     </InputLabel>

                            //     {/* <Select
                            //         labelId="demo-simple-select-label"
                            //         id="demo-simple-select"
                            //         value={fasciaTypeValue}
                            //         onChange={handleFasciaType}
                            //     >
                            //         <MenuItem value={"Timber Fascia Drop"}>Timber Fascia</MenuItem>
                            //         <MenuItem value={"Metal Fascia Drop"}>Metal Fascia</MenuItem>
                            //         <MenuItem value={"Beam"}>Beam</MenuItem>
                            //         <MenuItem value={"Riser"}>Riser</MenuItem>
                            //         <MenuItem value={"Wall"}>Wall</MenuItem>
                            //     </Select> */}
                            //     {/* <BSL_Select /> */}
                            // </FormControl>
                        )}
                        {!is_deck_mode && attachment_subtype_options && attachment_subtype_options.length > 0 && (
                            <BSL_Select
                                label={"Attachment Option"}
                                value={attachmentSubTypeValue}
                                tight={true}
                                items={attachment_subtype_options}
                                onChange={handleAttachmentSubType}
                                helperText={"*these options may not be reflected in the layout / 3d model"}
                            />
                        )}
                        <div>
                            <TextField
                                InputLabelProps={{ className: classes.label }}
                                label={"Custom Eave Width"}
                                value={eaveValue}
                                onChange={handleEaveValue}
                                helperText={"default:" + default_EaveDepth + "mm"}
                            />
                            <TextField
                                InputLabelProps={{ className: classes.label }}
                                label={"Custom Wall Height"}
                                value={wallHeightValue}
                                onChange={handleWallHeight}
                                helperText={"default:" + default_WallHeight + "mm"}
                            />
                        </div>
                        <Typography id="range-slider" gutterBottom>
                            Set Partial Attachment
                        </Typography>
                        <AttachmentSlider
                            ThumbComponent={AirbnbThumbComponent}
                            value={paatValues}
                            onChange={handlePaatValuesChange}
                            valueLabelDisplay="auto"
                            aria-labelledby="range-slider"
                            getAriaValueText={valuetext}
                            // valueLabelDisplay="on"
                            min={0}
                            max={max}
                        />
                        <div style={{ width: "100%" }}>
                            <span style={{ marginLeft: ((paatValues[1] + paatValues[0]) / 2 / max) * 100 - 6 + "%" }}>
                                <input
                                    type="text"
                                    id="standard-basic"
                                    label=""
                                    value={attsch_length_display}
                                    className={classes.attachLengthText}
                                    onChange={(e) => setAttachDisplay(e.target.value)}
                                    onBlur={() => {
                                        let new_value = [...paatValues];
                                        let new_end_pos = new_value[0] + toNumber(attsch_length_display);
                                        let start_end_adj = 0;
                                        if (new_end_pos > max) {
                                            start_end_adj = new_end_pos - max;
                                            new_end_pos = max;
                                        }

                                        new_value[0] = new_value[0] - toNumber(start_end_adj);
                                        new_value[1] = toNumber(new_end_pos);
                                        // console.log(new_value);
                                        setPaatValues(new_value);
                                        setAttachDisplay(null);
                                    }}
                                    onFocus={(event) => {
                                        event.target.select();
                                    }}
                                    onKeyPress={(e) => {
                                        if (e.key === "Enter") {
                                            e.target.blur();
                                        }
                                    }}
                                />
                            </span>
                            {/* <span style={{marginLeft: (((value[1] + value[0])/2)/max*100)-7 + "%"}}>{value[1] - value[0]+"mm"}</span> */}
                        </div>

                        {!is_deck_mode && (
                            <>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={paatGutterValue}
                                            onChange={handlePaatGutterChange}
                                            name="checkedB"
                                            color="primary"
                                        />
                                    }
                                    label="Omit Gutters on unattached Parts where allowable"
                                />
                                {(num_brackets > 0 ||
                                    attachmentTypeValue.includes("Flyover") ||
                                    (attachmentTypeValue === "" && default_FasciaType.includes("Flyover"))) && (
                                    // <>
                                    // <Typography id="range-slider" gutterBottom>
                                    //     Custom{" "}
                                    //     {attachmentTypeValue.includes("Flyover") ||
                                    //     (attachmentTypeValue === "" && default_FasciaType.includes("Flyover"))
                                    //         ? window.LYSAGHT
                                    //             ? "Jumbo"
                                    //             : "BK50"
                                    //         : ""}{" "}
                                    //     Brackets
                                    // </Typography>
                                    //     <FormControl className={classes.formControl}>
                                    //         <InputLabel style={{ width: "200%" }} id="demo-simple-select-label">
                                    //             Number of Brackets (min: {min_rafters}; recommended number (auto)=
                                    //             {recommended_brackets})
                                    //             {numBrackets && numBrackets < recommended_brackets && (
                                    //                 <>
                                    //                     <br />
                                    //                     <WarningIcon /> Warning: You have selected a number of brackets
                                    //                     less than recommended
                                    //                 </>
                                    //             )}
                                    //         </InputLabel>
                                    //         <Select
                                    //             labelId="demo-simple-select-label"
                                    //             id="demo-simple-select"
                                    //             value={numBrackets}
                                    //             onChange={handleNumBrackets}
                                    //         >
                                    //             <MenuItem value={0}>Auto</MenuItem>
                                    //             {rafterBracketMenuItems}
                                    //         </Select>
                                    //     </FormControl>
                                    // </>
                                    <BSL_Select
                                        label={
                                            "Custom " +
                                            (attachmentTypeValue.includes("Flyover") ||
                                            (attachmentTypeValue === "" && default_FasciaType.includes("Flyover"))
                                                ? window.LYSAGHT
                                                    ? "Jumbo "
                                                    : "BK50 "
                                                : "") +
                                            "Brackets"
                                        }
                                        value={numBrackets}
                                        tight={true}
                                        items={rafterBracketMenuItems}
                                        onChange={handleNumBrackets}
                                        helperText={
                                            <>
                                                Number of Brackets (min: {min_rafters}; recommended number (auto)=
                                                {recommended_brackets})
                                                {numBrackets > 0 && numBrackets < recommended_brackets && (
                                                    <>
                                                        <br />
                                                        <WarningIcon
                                                            style={{
                                                                color: "red",
                                                                height: "16px",
                                                                verticalAlign: "sub",
                                                            }}
                                                        />{" "}
                                                        Warning: You have selected a number of brackets less than
                                                        recommended
                                                    </>
                                                )}
                                            </>
                                        }
                                    />
                                )}
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={rSBLC}
                                            onChange={handleRSBLC}
                                            name="checkedB"
                                            color="primary"
                                        />
                                    }
                                    label="Allow Rafter Reinforcement for Rafter Brackets (RSBLC)"
                                />
                            </>
                        )}
                    </DialogContentText>
                )}
            </DialogContent>
            <DialogActions>
                <Button
                    autoFocus
                    onClick={handleDelete}
                    color="primary"
                    style={{
                        position: "absolute",
                        left: "20px",
                    }}
                >
                    Reset to Defaults
                </Button>
                <Button autoFocus onClick={handleClose} color="primary">
                    Cancel
                </Button>
                <Button onClick={saveAttachmentModifications} color="primary">
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
}

SpecModifyAttachmentDialog.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
};
